document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle is handled inline via onclick in header.liquid

  // Subtle 3D tilt on product cards following the cursor
  document.querySelectorAll('.product-card-3d').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var rotateX = ((y / rect.height) - 0.5) * -8;
      var rotateY = ((x / rect.width) - 0.5) * 8;
      card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
});
